import React, { useEffect, useState, useRef, forwardRef } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import columns, { rowStyle2 } from "./common/dependencies/internationTableColumn";
import Table from "../common/Table";
import "./scss/index.scss";
import Download from "../common/Download";
import SectionTitle from "../common/sectionTitle/sectionTitle";
import InputField from "../common/InputField";
import {
  getInternationalReportList,
  doDownloadResultList,
  saveNsaResultData,
  updateNSAReportList,
  lastGeneratedReportHistory,
  CountryName,
  ListOfEvent,
  GenerateInternatinalEventId,
  updateInternationalReportList,
  HistoryInternationalTag,
  EventName,
} from "../../dependencies/services/beneficiary";
import Button from "../common/Button";
import downArrowBtn from "../../assests/images/down-arrow-btn.png";
import calenderIcon from "../../assests/images/calender-icon.png";
import calenderIconAct from "../../assests/images/calendar-icon-act.png";
import downArrowBtnblack from "../../assests/images/down-arrow-btn-black.png";
import deleteIconGif from "../../assests/images/delete-icon.gif";
import { toast } from "react-toastify";
import Refresh from "../common/Refresh";
import { ROLES } from "../../constants/Roles";
import { storage } from "../../dependencies/store/storage";
import Select from "react-select";
import { uploadFileService } from "../../dependencies/services/uploadFileService";
import UploadInternationalBeneficiaries from "../UploadInternationalBeneficiaries";
import { isLoading } from "../../constants/actionConstants";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import moment from "moment";
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const InternationalEngagement = (props) => {
  const {
    getInternationalReportList,
    saveNsaResultData,
    internationalReportDataState: { data, recordsTotal, status, message },
    doDownloadResultList,
    isLoading,
    updateInternationalReportList,
    updateNSAReportList,
    lastGeneratedReportHistory,
  } = props;
  const [sortField, setSortField] = useState("applicationDate");
  const [sortOrder, setSortOrder] = useState("DESC");
  const [sizePerPage, setSizePerPage] = useState(20);
  const [openEventList, setOpenEventList] = useState(false)
  const [dropDownStatus, setDropDownStatus] = useState("text");
  const [edited, setEdited] = useState(null);
  const [pageNo, setPageNo] = useState(0);
  const [query, setQuery] = useState({
    internationalTag: true,
    archived: false,
  });
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const [countrySearchText, setCountrySearchText] = useState("");
  const [filteredCountryList, setFilteredCountryList] = useState([]);
  const countryInputRef = useRef(null);
  const [searchParams, setSearchParams] = useState({});
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  const [checkedValue, setCheckedValue] = useState([]);
  const [modalValue, setModalValue] = useState(false);
  const [buttonValue, setButtonValue] = useState("");
  const [bulkValue, setBulkValue] = useState({});
  const [natureOption, SetNatureOption] = useState([]);
  const [actionType, setActionType] = useState("");
  const [newApplication, setNewApplication] = useState(false);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showIncompleteHistory, setShowIncompleteHistory] = useState(false);
  const [exemptionId, setExemptionId] = useState("");
  const [diiptNumber, setDiiptNumber] = useState("");
  const [error, setError] = useState("");
  const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] =
    useState(false);
  const [nsaResultView, setNsaResultView] = useState(false);
  const [openSelectDropdown, setOpenSelectDropdown] = useState(false);
  const [openNSAYearDropdown, setOpenNSAYearDropdown] = useState(false);
  const [openSelectFilterDropdown, setOpenSelectFilterDropdown] =
    useState(false);
  const [openNSAYearFilterDropdown, setOpenNSAYearFilterDropdown] =
    useState(false);
  const [selectFilter, setSelectFilter] = useState("Country");
  const [nsaYearFilter, setNsaYearFilter] = useState("Year of Engagement");
  const [select, setSelect] = useState("Country");
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [rigthSelectCountry, setRigthSelectCountry] = useState("Country Name")
  const [openRigthSideCountry, setOpenRigthSideCountry] = useState(false)
  const [selectevent, setSelectEvent] = useState("Event Name");
  const [eventName, setEventName] = useState("");
  const [yearOfEngagement, setYearOfEngagement] = useState("");
  const [selectFilters, setSelectFilters] = useState("Name of the Event");
  const [errors, setErrors] = useState({});
  const [nsaYear, setNsaYear] = useState("Year of Engagement");
  const [searchDisable, setSearchDisable] = useState(true);
  const [saveDisable, setSaveDisable] = useState(true);
  const [nameOfEntity, setNameOfEntity] = useState("");
  const [incorporationNumber, setIncorporationNumber] = useState("");
  const [incorporationDate, setIncorporationDate] = useState("");
  const [certificateNumber, setCertificateNumber] = useState("");
  const [fileUploadMessage, setFileUploadMessage] = useState("");
  const [openDeletemodal, setOpenDeletemodal] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [DeleteConfirmationStatus, setDeleteConfirmationStatus] =
    useState(false);
  const [selectedRows, setSelectedRows] = useState(null);
  const [showCustomEditNSA, setShowCustomEditNSA] = useState(false);
  const [statusNsaUpdate, setStatusNsaUpdate] = useState(null);
  const [yearNsaUpdate, setYearNsaUpdate] = useState(null);
  const [nsaUpdate, setNsaUpdate] = useState({ eventId: "", dippNumber: "" });
  const [nsaDeleteAction, setNsaDeleteAction] = useState("ALL");
  const [historyData, setHistoryData] = useState({});
  const [openHistory, setOpenHistory] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState([]);

  const dispatch = useDispatch()
  const [eventList, setEventList] = useState([]);
  const [eventNames , setEventNames] = useState()

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [selectedStatusNSA, setSelectedStatusNSA] = useState([]);
  const [selectedYearNSA, setSelectedYearNSA] = useState([]);
  const [deleteTagOptions, setDeleteTagOptions] = useState([]);
  const userRole = storage.getUserRole();

  const [isInternationalModalOpen, setIsInternationalModalOpen] = useState(false);
  const [deleteConfirmationSelection, setDeleteConfirmationSelection] = useState(null);
  const [listOfEventData, setListOfEventData] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');

  const history = useHistory();
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenSelectFilterDropdown(false);
      setOpenRigthSideCountry(false);
      // setOpenEventList(false); 
      setOpenNSAYearFilterDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openInternationalModal = () => {
    setIsInternationalModalOpen(true);
  };

  const closeInternationalModal = () => {
    setIsInternationalModalOpen(false);
  };

  const StatusNSA = [
    { value: "W", label: "Winner" },
    { value: "F", label: "Finalist" },
  ];

  const yearNSA = [
    { value: "2019", label: "2019" },
    { value: "2020", label: "2020" },
    { value: "2021", label: "2021" },
    { value: "2022", label: "2022" },
    { value: "2023", label: "2023" },
    { value: "2024", label: "2024" },
  ];
  useEffect(() => {
    getTableData();
  }, [
    sortField,
    sortOrder,
    sizePerPage,
    pageNo,
    searchParams,
    query,
    searchText,
  ]);



  useEffect(() => {
    dispatch(EventName()).then((data) => {
      setEventNames(data.data);
    })

    dispatch(CountryName()).then((response) => {
      if (response?.data) {
        setCountryList(response.data);
      }
    });

  }, []);

  useEffect(() => {
    // Initialize filtered list with all countries
    if (countryList && countryList.length > 0) {
      if (!countrySearchText.trim()) {
        setFilteredCountryList(countryList);
      } else {
        const filtered = countryList.filter(country =>
          country.countryName.toLowerCase().includes(countrySearchText.toLowerCase())
        );
        setFilteredCountryList(filtered);
      }
    }
  }, [countrySearchText, countryList]);

  const handleCountryInputFocus = () => {
    setIsCountryDropdownOpen(true);
  };
  const handleCountryInputChange = (e) => {
    setCountrySearchText(e.target.value);
  };


  const handleCountrySelect = (countryName) => {
    const isSelected = selectedCountry.includes(countryName);
    let newSelection;
    
    if (isSelected) {
      newSelection = selectedCountry.filter(item => item !== countryName);
    } else {
      newSelection = [...selectedCountry, countryName];
    }
    
    setSelectedCountry(newSelection);
    if (countryInputRef.current) {
      countryInputRef.current.focus();
    }
  };

  const removeCountry = (countryToRemove) => {
    setSelectedCountry(selectedCountry.filter(country => country !== countryToRemove));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (countryInputRef.current && !countryInputRef.current.contains(event.target)) {
        setIsCountryDropdownOpen(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const getTableData = () => {
    getInternationalReportList({
      sortColumn: sortField,
      sortOrder: sortOrder.toUpperCase(),
      pageSize: sizePerPage,
      pageIndex: pageNo,
      query,
    });
  };


  function openEditModal() {
    setOpenDeletemodal(true);
  }

  const openInternationlModal = async () => {
    let data = await HistoryInternationalTag();
    if (data) {
      setHistoryData(data);
    }
    setOpenHistory(true);
  };

  const closeHistoryModal = () => {
    setOpenHistory(false);
  };






  const openHistoryModal = async () => {
    let data = await HistoryInternationalTag();
    if (data) {
      setHistoryData(data.data);
    }
    setOpenHistory(true);
  };

  // const closeHistoryModal = () => {
  //   setOpenHistory(false);
  // };

  const closeConfirmationModal = () => {
    setOpenConfirmation(false);
  };

  function openConfirmationModal() {
    setDeleteConfirmationSelection(null);
    setShowDeleteConfirmation(false);
    setOpenConfirmation(true);
  }

  const toggleDeleteModal = () => {
    setOpenDeletemodal(false);
    setShowCustomEditNSA(false);
    setNsaDeleteAction("ALL");
    setNsaUpdate({ tag: "", dippNumber: "" });
    setYearNsaUpdate(null);
    setStatusNsaUpdate(null);
  };

  const handleConfirmation = (e) => {
    const isConfirmedDelete = e.target.value === "yes";
    setDeleteConfirmationSelection(isConfirmedDelete ? "yes" : "no");
    setShowDeleteConfirmation(true);
    setDeleteConfirmationStatus(isConfirmedDelete);
  };

  const handleDeleteNsaRecord = () => {

    if (DeleteConfirmationStatus) {
      handleUpdateSubmit();
    }
    closeConfirmationModal();
  };


  const updateTagDeleteOptions = (options) => {

    if (!Array.isArray(options)) return;

    const formattedOptions = options.map((tag) => ({
      value: tag.eventId,
      label: tag.eventId,
    }));

    const optionsWithTags = [
      { value: "", label: "Select Event ID", isDisabled: true },
      ...formattedOptions,
    ];

    setDeleteTagOptions(optionsWithTags);
  };


  const handleEditClick = (row) => {

    const updateNsaObj = { ...nsaUpdate };
    updateNsaObj.dippNumber = row?.certificateNumber;
    setNsaUpdate(updateNsaObj);

    updateTagDeleteOptions(row?.internationalTag?.
      internationalTags
    );
    setSelectedRows(row);
    openEditModal();
  };


  const onSortChange = async (params) => {
    const { order, dataField } = params;
    const newOrder = sortOrder === "DESC" ? "ASC" : "DESC";
    let sortName = "";
    if (dataField === "mobileNumber") {
      sortName = "representative.mobile";
    } else if (dataField === "referenceNumber") {
      sortName = "referenceNumber";
    } else if (dataField === "certificateNumber") {
      sortName = "startupEntity.recognitionNumber";
    } else if (dataField === "incorporationNumber") {
      sortName = "incorporationNumber";
    } else if (dataField === "nameOfEntity") {
      sortName = "startupEntity.name";
    } else if (dataField === "applicationDate") {
      sortName = "applicationDate";
    } else if (dataField === "registrationDate") {
      sortName = "startupEntity.corCreatedDate";
    } else if (dataField === "emailId") {
      sortName = "representative.email";
    } else {
      sortName = "createdDate";
    }
    if (dataField !== "") {
      setSortField(sortName);
      // setSortOrder(order.toUpperCase());
      setSortOrder(newOrder);
    }
  };
  const handleOnPageChange = (params) => {
    const { page } = params;
    setPageNo(page - 1);
  };
  const handleOnSizePerPageChange = (params) => {
    const { sizePerPage } = params;
    setSizePerPage(sizePerPage);
    setPageNo(0);
  };

  useEffect(() => {
    if (data && status) {
      setNameOfEntity(data[0]?.nameOfEntity);
      setIncorporationDate(data[0]?.incorporationDate);
      setIncorporationNumber(data[0]?.incorporationNumber);
      setCertificateNumber(data[0]?.certificateNumber);
    } else {
      toast.error(message);
      // setNsaResultView(false)
    }
  }, [data]);

  const toggleActionModal = () => {
    setModalValue(!modalValue);
    if (modalValue) {
      setActionType("");
    }
  };

  const actionHandler = (actionType) => {
    setActionType(actionType);
  };
  useEffect(() => {
    if (checkedValue.length === 0 && actionType) {
      setButtonValue("invalid");
      toggleActionModal();
    } else {
      bulkApprove();
    }
  }, [actionType]);

  const bulkApprove = () => {
    if (actionType === "approved") {
      toggleActionModal();
      setButtonValue("approved");
      setBulkValue({
        ids: checkedValue,
        status: "APPROVE",
      });
    } else if (actionType === "archived") {
      toggleActionModal();
      setButtonValue("archived");
      setBulkValue({
        ids: checkedValue,
        status: "ARCHIVE",
      });
    }
  };
  function downloadNSAResultList() {
    if (doDownloadResultList) {
      return doDownloadResultList({
        fetchAllRecords: true,
        sortColumn: sortField,
        sortOrder: sortOrder.toUpperCase(),
        pageSize: sizePerPage,
        pageIndex: pageNo,
        query,
      }).then((data) => {
        return data;
      });
    }
  }

  useEffect(() => {
    if (props.getSectorOptions) {
      props.getSectorOptions().then((response) => {
        const { data = [] } = response;
        let options = [];
        if (data && data instanceof Array) {
          options = data.reduce((arr, option) => {
            if (option["industryName"] !== null) {
              var text =
                `${option["sectionName"]} (${option["industryName"]})` || "";
            } else {
              var text = `${option["sectionName"]}` || "";
            }
            const value = option["id"] || "";
            arr.push({ text, value });
            return arr;
          }, []);
        }
        setSectorOptions(options);
      });
    }

  }, []);

  useEffect(() => {
    if (exemptionId) {
      setShowIncompleteHistory(true);
    }
  }, [exemptionId]);
  const clickOnAction = (id) => {
    if (id) {
      setExemptionId(id);
    }
  };
  useEffect(() => {
    if (selectFilter != "Select By" && nsaYearFilter != "NSA Year") {
      setSearchDisable(false);
    }
  }, [nsaYearFilter, selectFilter]);

  useEffect(() => {
    if (select != "Select By" && nsaYear != "NSA Year") {
      setSaveDisable(false);
    }
  }, [nsaYear, select]);



  const handleOpenSelectDropdown = () => {
    setOpenSelectDropdown(!openSelectDropdown);
  };


  const handleOpenNSAYearDropdown = () => {
    setOpenNSAYearDropdown(!openNSAYearDropdown);
  };
  const handleOpenNSAYearFilterDropdown = () => {
    setOpenNSAYearFilterDropdown(!openNSAYearFilterDropdown);
  };

  const handleSelectByFilter = (event, value) => {
    setSelectFilter(value);
    setOpenSelectFilterDropdown(false);
  };

  const handleNSAYearFilter = (event, value) => {
    setNsaYearFilter(value); // Set the selected value
    setOpenNSAYearFilterDropdown(false);
  };

  const handleUpdateSubmit = async () => {
    try {
      if (!nsaDeleteAction) {
        toast.error("Please select a valid Tag");
        return;
      }

      const isAllSelected = nsaDeleteAction === "ALL";

      if (!isAllSelected && nsaUpdate.eventId === "") {
        toast.error("Tag selection is required. Please make a selection.");
        return;
      }

      const data = await updateInternationalReportList({
        query: nsaUpdate,
        params: nsaDeleteAction,
      });

      if (data.status) {
        getTableData();
        setOpenDeletemodal(false);
        setNsaDeleteAction("ALL");
        setNsaUpdate({ eventId: "", dippNumber: "" });
        setYearNsaUpdate(null);
        setStatusNsaUpdate(null);
        toast.success(data?.message);
        setShowCustomEditNSA(false);
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };



  const handleSearchBySelect = () => {
    setQuery(() => {
      return {
        internationalTag: true,
        archived: false,
        startupInternationalTag: {
          // eventId: eventId, // Make sure eventId is defined in your scope
          ...(rigthSelectCountry !== "Country Name" && { hostedCountry: rigthSelectCountry }),
          ...(selectevent !== "Event Name" && { eventName: selectevent }),
          ...(nsaYearFilter !== "Year of Engagement" && { yearOfEngagement: nsaYearFilter })
        }
      };
    });
  };



  const onUploadFile = (file) => {
    isLoading(true);
    const data = new FormData();
    data.append("file", file);
    uploadFileService.uploadFileInternatinalBtn(data).then(
      (data) => {
        if (data?.status) {
          toast.success(
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              <ul>
                {data.message.split("\n").map((line, index) => (
                  <li key={index} className="py-1">
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          );
          getTableData();
        } else {
          toast.error(
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              <ul>
                {data.message.split("\n").map((line, index) => (
                  <li key={index} className="py-1">
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          );
          isLoading(false);
        }
      },
      (error) => {
        toast.error(error);
        isLoading(false);
      }
    );
  };

  const setFileUploadSuccessMessage = (message) => {
    setFileUploadMessage(message);
  };

  const handleUpdateTag = (e) => {
    setNsaDeleteAction(e.target.value);
    if (e.target.value == "CUSTOM") {
      setShowCustomEditNSA(true);
      setNsaUpdate({ eventId: "", dippNumber: "" });
    } else {
      setShowCustomEditNSA(false);
    }
  };




  const handleDeleteNsaTagUpdate = (selectedOption) => {
    const { value } = selectedOption;
    setNsaUpdate({ ...nsaUpdate, eventId: value });
  };


  const handleOpenSelectFilterDropdown = () => {
    setOpenSelectFilterDropdown(!openSelectFilterDropdown);
  };

  const handleOpenEventListDropdown = () => {
    setOpenEventList(!openEventList);
  };

  // const handleCountrySelect = (country) => {
  //   setSelectedCountry(country);
  //   setOpenSelectFilterDropdown(false);

  // };

  const handleSetOpenRigthSideCountry = () => {
    setOpenRigthSideCountry(!openRigthSideCountry)
  }

  const handleRigthSelectCountry = (country) => {
    setRigthSelectCountry(country)
    setOpenRigthSideCountry(false)
    setSearchTerm("")
  }

  const filteredCountries = countryList.filter((country) =>
    country.countryName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleEventList = (eventName) => {
    setSelectEvent(eventName);
    setOpenEventList(false);
  };

  let nsaYearArray = ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024"];
  const validateForm = () => {
    const newErrors = {};
    if (selectedCountry.length === 0) {
      newErrors.selectedCountry = "Please select at least one country.";
    }

    if (!eventName.trim()) {
      newErrors.eventName = "Event name is required.";
    }

    if (!yearOfEngagement) {
      newErrors.yearOfEngagement = "Please select a year.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const handleGenerateInternationalEventId = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      hostedCountry: selectedCountry,
      eventName: eventName,
      yearOfEngagement: yearOfEngagement,
    };

    dispatch(GenerateInternatinalEventId(payload)).then((value) => {
      if (value.status) {
        setIsInternationalModalOpen(false)
        toast.success(value.message + " Event ID: " + value.data.eventId)

        dispatch(EventName()).then((data) => {
          setEventNames(data.data);
        })
      }
      else{
        setIsInternationalModalOpen(false)
        toast.error(value.message)
      }

    });
  };



  const navigateToListOfEvents = () => {
    history.push({
      pathname: "/international-engagements/lists-of-events",
      state: { eventList },
    });
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.contentEventList')) {
        setOpenEventList(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const CustomDatePickerInput = forwardRef(({ value, onClick }, ref) => (
    <div className="custom-date-picker-input" onClick={onClick} ref={ref}>
      <input
        type="text"
        value={value}
        readOnly
        placeholder="Year of Engagement"
        className="form-control"
      />
      <img
        width="15px"
        src={calenderIcon}
        className="showicon-black"
      />
      <img
        src={calenderIconAct}
        width="15px"
        className="showicon-white"
      />
    </div>
  ));

  return (
    <div>
      <SectionTitle>International Engagements</SectionTitle>
      <div className="startup-app-filter-form-results">
        <div className="row  results-row ">
          <div className="col-md-7 col-xl-6">
            {userRole === ROLES.SUPER_ADMIN && (
              <>
                <div className="inner-wrap clearfix">
                  <div className="left-filter-wrap internation-flex">
                    <div className="nsa-results">
                      {
                        <>
                          <UploadInternationalBeneficiaries
                            onUploadFile={onUploadFile}
                            allowedFiles={[".xlsx", ".xls", ".csv"]}
                            successMessage={fileUploadMessage}
                            setSuccessMessage={setFileUploadSuccessMessage}
                          />
                        </>
                      }
                    </div>
                    {/* <div>
                  <button className='history-btn' onClick={openHistoryModal}>Last Updated</button>
                  </div> */}
                    <div className={`button-wrap`}>
                      <Button
                        className={`bttn blueGradient`}
                        text="Generate International Event ID" onClick={openInternationalModal}
                      />
                    </div>
                    <div className={`button-wrap`}>
                      {/* <a href="/international-engagements/lists-of-events" target="_blank" > */}
                      <Button
                        onClick={navigateToListOfEvents}
                        className={`bttn blueDarkGradient`}
                        text="List of Events"

                      />
                      {/* </a> */}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="col-md-5 col-xl-6">
            {!nsaResultView && (
              <div className="row mt-0 mb-2 mt-0 justify-content-end ml-0 mr-0">
                <div className="inner-wrap clearfix">
                  <div className="left-filter-wrap internation-flex">
                    <div
                      ref={dropdownRef}
                      onClick={handleOpenNSAYearFilterDropdown}
                      className={`download-container bttn dropdown-check dropdown-check-list engamentYear ${openNSAYearFilterDropdown ? "show" : ""
                        }`}
                    >
                      {/* {nsaYearFilter}{" "} */}
                      <DatePicker
                        selected={nsaYearFilter !== "Year of Engagement" ? new Date(nsaYearFilter, 0, 1) : null}
                        onChange={(date) => setNsaYearFilter(moment(date).year())}
                        showYearPicker
                        dateFormat="yyyy"
                        maxDate={new Date()}
                        placeholderText="Year of Engagement"
                        customInput={<CustomDatePickerInput />}
                      />
                      {/* <img
                        width="15px"
                        src={calenderIcon}
                        className="showicon-black"
                        onClick={() => setOpenNSAYearFilterDropdown(true)}
                      />
                      <img
                        src={calenderIconAct}
                        width="15px"
                        className="showicon-white"
                      /> */}
                    </div>

                    <div
                      ref={dropdownRef}
                      onClick={handleSetOpenRigthSideCountry}
                      className={`download-container bttn dropdown-check dropdown-check-list countryList ${openRigthSideCountry ? "show" : ""
                        }`}
                    >
                      {
                        <span>{rigthSelectCountry}
                        </span>
                      }{" "}
                      <img
                        width="15px"
                        src={downArrowBtnblack}
                        className="showicon-black"
                      />
                      <img
                        src={downArrowBtn}
                        width="15px"
                        className="showicon-white"
                      />
                      {openRigthSideCountry && (
                        // <div className="search-dropDown">
                          
                          <ul >
                            <input
                            type="text"
                            placeholder="Search Country..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onClick={(e) => e.stopPropagation()}  />
                            {filteredCountries.map((country, index) => (
                              <li
                                key={index}
                                onClick={(e) => {
                                  e.stopPropagation(); 
                                  handleRigthSelectCountry(country.countryName);
                                }}
                                style={{ cursor: 'pointer', padding: '5px 0' }}
                              >
                                {country.countryName}
                              </li>
                            ))}
                            {filteredCountries.length === 0 && <li>No country found</li>}
                          </ul>
                        // </div>
                      )}


                    </div>

                    <div
                      onClick={handleOpenEventListDropdown}
                      className={`download-container bttn dropdown-check dropdown-check-list contentEventList ${openEventList ? "show" : ""
                        }`}
                    >
                      <span> {selectevent}{" "}</span>
                      <img
                        width="15px"
                        src={downArrowBtnblack}
                        className="showicon-black"
                      />
                      <img
                        src={downArrowBtn}
                        width="15px"
                        className="showicon-white"
                      />
                      {openEventList && (
                        <ul style={{ backgroundColor: '#fff', color: '#000' }}>
                          {eventNames.map((event, index) => (

                            <li key={index} onClick={() => handleEventList(event)}
                            style={{ cursor: 'pointer' }}>
                              {event}
                            </li>
                          ))}
                        </ul>
                      )}

                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="row mt-3 results-row">
          <div className="col-md-10 col-xl-10">
            {userRole === ROLES.SUPER_ADMIN && (
              <>
                <div className="inner-wrap clearfix">
                  <div className="left-filter-wrap">
                    <button className="history-btn" onClick={openHistoryModal}>
                      Last Updated
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="col-md-2 col-xl-2">
            <div className="button-wrap">
              <Button
                className="bttn submit-bnt submitBtnWidth"
                type="submit"
                text="Search"
                onClick={handleSearchBySelect}
                disabled={searchDisable}
              />
            </div>
          </div>
        </div>


        <>
          <div className="row" style={{ marginTop: "15px" }}>
            <div
              className="col-sm-12 mt-3 w-100"
              style={{ paddingRight: "24px" }}
            >
              <Download
                fileName={"International Engagement Details"}
                onClickDownload={downloadNSAResultList}
                className="bttn-link"
              />
            </div>
          </div>
          <Table
            dataTable={data}
            columns={columns({
              handleEditClick: handleEditClick,
              clickOnAction,
              pageNo: pageNo,
              size: sizePerPage,
            })}
            keyField="applicationId"
            onSortChange={onSortChange}
            totalSize={recordsTotal}
            rowStyle={rowStyle2}
            sizePerPage={sizePerPage}
            onPageChange={handleOnPageChange}
            onSizePerPageChange={handleOnSizePerPageChange}
            actionHandler={actionHandler}
          />
        </>

      </div>
      <Modal
        isOpen={openDeletemodal}
        toggle={toggleDeleteModal}
        className="nsa-report"
      >
        <ModalHeader toggle={toggleDeleteModal} className="nsa-modal-title">
          Delete record for this event
        </ModalHeader>
        <ModalBody className="mt-3 mb-3">
          <div className="row">
            <div className="tags-select col-md-6 my-2">
              <div className="d-flex justify-content-center align-items-center">
                <input
                  type="radio"
                  id="custom"
                  name="dateRange"
                  value="CUSTOM"
                  className="nsa-tag-modal-edit"
                  onChange={handleUpdateTag}
                />
                <label className="nsa-tag-modal-label" htmlFor="custom">
                  Custom
                </label>
              </div>
            </div>
            <div className="tag-select col-md-6">
              <div className="d-flex justify-content-center align-items-center">
                <input
                  type="radio"
                  id="all"
                  name="dateRange"
                  value="ALL"
                  defaultChecked
                  className="nsa-tag-modal-edit"
                  onChange={handleUpdateTag}
                />
                <label className="nsa-tag-modal-label" htmlFor="all">
                  All
                </label>
              </div>
            </div>
          </div>


          {showCustomEditNSA && (
            <div className="row nsa-edit-selectbox mt-4 mx-4">
              <div className="col-md-12">
                <label htmlFor="nsa-tag">Select Event ID</label>
                <Select
                  id="nsa-tag"
                  name="nsa-tag"
                  onChange={handleDeleteNsaTagUpdate}
                  options={deleteTagOptions}
                  defaultValue={deleteTagOptions[0]}
                  placeholder="Tag"
                  className="NsaTagSelection"
                  styles={{
                    control: (base) => ({
                      ...base,
                      backgroundColor: "#F5F5F5",
                      color: "white",
                      borderColor: "#ECECEC",
                      ":hover": {
                        borderColor: "#F5F5F5",
                      },
                    }),
                  }}
                />
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <div className="button-container">

            <button
              className="download-container nsa-delete-btn mb-3"
              disabled={
                showCustomEditNSA &&
                nsaUpdate.eventId === "" &&
                nsaDeleteAction !== "ALL"
              }
              onClick={openConfirmationModal}
            >
              Delete
            </button>
          </div>
        </ModalFooter>
      </Modal>

      {/* Confirmation Modal */}
      <Modal
        isOpen={openConfirmation}
        toggle={closeConfirmationModal}
        className="confirmation-nsa-delete-modal"
      >
        <ModalBody className="">
          <div className="row">
            <div className="confirmation-delete-icon col-md-12 mt-1 text-center">
              <img
                width="125px"
                src={deleteIconGif}
                className="showicon-black"
              />
            </div>
            <div className="confirmation-delete-message col-md-12  mb-2 text-center">
              <h4 className="mx-5">
                Are you sure you want to delete this record?
              </h4>
            </div>
          </div>
          <div className="row">
            <div className="d-flex justify-content-center align-items-center col-md-6">
              <input
                type="radio"
                id="delete-yes"
                name="deleteConfiramtion"
                value="yes"
                className="form-check-input nsa-tag-delete-confirmation"
                onChange={handleConfirmation}
              />
              <label
                className="form-check-label nsa-tag-modal-label h5 my-2"
                htmlFor="delete-yes"
              >
                Yes
              </label>
            </div>
            <div className="d-flex justify-content-center align-items-center col-md-6">
              <input
                type="radio"
                id="delete-no"
                name="deleteConfiramtion"
                value="no"
                className="form-check-input nsa-tag-delete-confirmation"
                onChange={handleConfirmation}
              />
              <label
                className="form-check-label nsa-tag-modal-label h5 my-2"
                htmlFor="delete-no"
              >
                No
              </label>
            </div>
          </div>
        </ModalBody>
        {showDeleteConfirmation && (
          <ModalFooter>
            <div className="button-container">

              <button
                className="download-container nsa-delete-btn mb-3"
                disabled={deleteConfirmationSelection === null}
                onClick={handleDeleteNsaRecord}
              >
                Ok
              </button>
            </div>
          </ModalFooter>
        )}
      </Modal>

      {/* History Modal */}
      <Modal
        isOpen={openHistory}
        toggle={closeHistoryModal}
        className="last-generated-report"
      >
        <ModalHeader toggle={closeHistoryModal}>Last Updated</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="last-generated">
              <ul>
                <li>
                  <strong>Name : </strong> <p>{historyData["adminName"]}</p>
                </li>
                <li>
                  <strong>Action : </strong>
                  <p>{historyData["action"]?.replace(/_/g, " ")}</p>
                </li>


                <li>
                  <strong>Action Date : </strong>{" "}
                  <p>
                    {moment(historyData["actionDate"]).format("DD/MM/YYYY")}
                  </p>
                </li>
                {/* <li><strong>Type : </strong> <p>{historyData['updateType']}</p></li> */}
                <li>
                <strong>Type : </strong> <p>{historyData["updateType"]}</p>
                </li>
              </ul>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="button-container">
            <button
              className="download-container downloadReport-Generated"
              onClick={(event) => closeHistoryModal(event)}
            >
              Ok
            </button>
          </div>
        </ModalFooter>
      </Modal>


      {/* form Modal */}
      <Modal
        isOpen={isInternationalModalOpen}
        toggle={closeInternationalModal}
        className="last-generated-report internationForm"
      >
        <ModalHeader toggle={closeInternationalModal}>Generate International Event ID</ModalHeader>
        <ModalBody>
          <form onSubmit={handleGenerateInternationalEventId}>
            <div className="row">




            <div className="col-md-6">
  <div className="form-group">
    <label>Select Host Country</label>
    <div className="country-dropdown-container" ref={countryInputRef}>
      {/* Main selector div that shows selected countries */}
      <div 
        className="country-selector" 
        onClick={handleCountryInputFocus}
      >
        {selectedCountry.length > 0 ? (
          selectedCountry.map((country, index) => (
            <span key={index} className="selected-country-tag">
              {country}
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  removeCountry(country);
                }}
                className="remove-country-btn"
                type="button"
              >
                ×
              </button>
            </span>
          ))
        ) : (
          <span className="placeholder-text">Search or select countries...</span>
        )}
      </div>
      
      {/* Dropdown that contains search input and country list */}
      {isCountryDropdownOpen && (
        <div className="country-dropdown-list">
          {/* Search input only visible when dropdown is open */}
          <div className="country-search-container">
            <input
              type="text"
              className="form-control"
              placeholder="Search countries..."
              value={countrySearchText}
              onChange={handleCountryInputChange}
              autoFocus
            />
          </div>
          
          {/* Country list */}
          <ul className="country-list">
            {filteredCountryList.length > 0 ? (
              filteredCountryList.map((country, index) => (
                <li key={index} onClick={() => handleCountrySelect(country.countryName)}>
                  <input
                    type="checkbox"
                    checked={selectedCountry.includes(country.countryName)}
                    onChange={() => {}} 
                    readOnly
                  />
                  <span>{country.countryName}</span>
                </li>
              ))
            ) : (
              <li>No countries found</li>
            )}
          </ul>
        </div>
      )}
    </div>
    {errors.selectedCountry && (
      <small className="text-danger">{errors.selectedCountry}</small>
    )}
  </div>
</div>

              {/* <div className="col-md-6">
                <div class="form-group">
                  <label >Name of Event</label>
                  <input
                    type="text"
                    class="form-control"
                    value={eventName}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = /^[a-zA-Z0-9\s\-\_\&\(\)\:\.\/]*$/;
                      if (regex.test(value)) {
                        setEventName(value);
                      }
                    }}
                    placeholder="Enter Event Name"
                  />
                </div>
                {openSelectFilterDropdown && (
                  <ul style={{ backgroundColor: "#fff", color: "#000" }}>
                    {countryList.map((country, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          const updatedSelection = selectedCountry.includes(
                            country.countryName
                          )
                            ? selectedCountry.filter(
                              (c) => c !== country.countryName
                            )
                            : [...selectedCountry, country.countryName];
                          setSelectedCountry(updatedSelection);
                        }}
                      >
                        {country.countryName}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              {errors.selectedCountry && (
                <small className="text-danger">{errors.selectedCountry}</small>
              )} */}



              {/* Event Name */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>Name of the Event</label>
                  <input
                    type="text"
                    className="form-control"
                    value={eventName}
                    onChange={(e) => {
                      const value = e.target.value;
                      const regex = /^[a-zA-Z0-9\s\-\_\&\(\)\:\.]*$/;
                      if (regex.test(value)) {
                        setEventName(value);
                      }
                    }}
                    placeholder="Enter event name"
                  />
                  {errors.eventName && (
                    <small className="text-danger">{errors.eventName}</small>
                  )}
                </div>
              </div>

              {/* Year of Engagement */}
              {/* <div className="col-md-6">
            <div className="form-group">
              <label>Year Of Engagement</label>
              <select
                className="form-control"
                value={yearOfEngagement}
                onChange={(e) => setYearOfEngagement(e.target.value)}
              >
                <option value="" disabled>
                  Select a Year
                </option>
                <option>2016</option>
                <option>2017</option>
                <option>2018</option>
                <option>2019</option>
                <option>2020</option>
                <option>2021</option>
                <option>2022</option>
                <option>2023</option>
                <option>2024</option>
                <option>2025</option>
              </select>
              {errors.yearOfEngagement && (
                <small className="text-danger">{errors.yearOfEngagement}</small>
              )}
            </div>
          </div> */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>Year Of Engagement</label>
                  <DatePicker
                    selected={yearOfEngagement ? new Date(yearOfEngagement, 0, 1) : null}
                    onChange={(date) => setYearOfEngagement(moment(date).year())}
                    showYearPicker
                    dateFormat="yyyy"
                    maxDate={new Date()}
                    className="form-control"
                    placeholderText="Select a Year"
                  />
                  {errors.yearOfEngagement && (
                    <small className="text-danger">{errors.yearOfEngagement}</small>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              <div className="col-md-6">
                <div className="button-container">
                  <button
                    type="submit"
                    className="download-container downloadReport-Generated"
                  >
                    Create
                  </button>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>

      </Modal >
    </div >
  );
};

const mapStateToProps = (state) => {
  return {
    // natureOfTheEntity: state.startupApplicationForm.natureOfTheEntity,
    // startupSectionList: state.startupSectionList.startupSelectionData,
    internationalReportDataState: state.internationalReportList1.internationalReportData,
  };
};

export default connect(mapStateToProps, {
  getInternationalReportList,
  saveNsaResultData,
  doDownloadResultList,
  isLoading,
  updateInternationalReportList,
  updateNSAReportList,
  lastGeneratedReportHistory,
})(withRouter(InternationalEngagement));



